import { Checkbox, Col, Form, Input, Row } from "antd";
import { CentroCostoSelect } from "../reusable/CentroCostoSelect";
import { useEffect } from "react";

export const CuentaContableDiv = () => {
  const form = Form.useFormInstance();
  const tienecuentacontable = Form.useWatch("tienecuentacontable", form);
  useEffect(() => {
    if (!tienecuentacontable)
      form.setFieldsValue({ centrocosto: null, cuentacontable: null });
  }, [tienecuentacontable]);

  return (
    <>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item name="tienecuentacontable" valuePropName="checked">
            <Checkbox>Tiene cuenta contable</Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        style={!tienecuentacontable && { display: "none" }}
      >
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item name="centrocosto">
            <CentroCostoSelect placeholder="[-Seleccione centro costo-]" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item name="cuentacontable">
            <Input placeholder="Cuenta contable" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
